import axiosInstance from '../../../api/axiosConfig';

const custodiaService = {
  // ===== SOURCES =====
  searchSources: (query, type) =>
    axiosInstance.get('/custodia/sources/search', { params: { q: query, type } }),

  // ===== CONVERSATIONS =====
  createConversation: (sourceConfig, mode = 'custodia', entityId = null) =>
    axiosInstance.post('/custodia/conversations', { sourceConfig, mode, entityId }),

  getConversations: (mode = null) =>
    axiosInstance.get('/custodia/conversations', { params: mode ? { mode } : {} }),

  getConversation: (id) =>
    axiosInstance.get(`/custodia/conversations/${id}`),

  deleteConversation: (id) =>
    axiosInstance.delete(`/custodia/conversations/${id}`),

  // ===== CHAT =====
  sendMessage: (conversationId, question) =>
    axiosInstance.post(`/custodia/conversations/${conversationId}/chat`, { question }),

  // ===== STATS =====
  getStats: () =>
    axiosInstance.get('/custodia/stats'),
};

export default custodiaService;
